export enum VesselStopTypeForStepper {
    Arrival = "ARRIVAL",
    Departure = "DEPARTURE",
    Shift = "SHIFT"
}